import { isString } from 'lodash'

export function handleCommon (payload, schema, operator) {
  const criteria = []
  schema.forEach((key) => {
    const _key = key
    if (typeof key === 'object') {
      key = key.field
    }
    if ((payload[key] && operator !== 'LIKE') || payload[key] === 0 || payload[key] === false) {
      const valueKey = operator === 'IN' ? 'values' : 'value'
      const item = {
        field: key,
        operator,
        [valueKey]: payload[key]
      }
      if (key !== _key) {
        item.type = _key.type
      }
      criteria.push(item)
    }
    if (payload[key] && operator === 'LIKE') {
      const item = {
        field: key,
        operator: 'LIKE',
        value: payload[key]
      }
      criteria.push(item)
    }
  })
  return criteria
}

export function handleBetween (payload, schema) {
  const criteria = []
  schema.forEach(item => {
    const { field, min, max, type } = item
    if (payload[min] && payload[max] && field) {
      criteria.push({
        field,
        operator: 'BETWEEN',
        min: payload[min],
        max: payload[max],
        type
      })
    }
  })
  return criteria
}

export function convertCriteriaForId (fieldName, value) {
  const _val = value && isString(value) ? value : `${value || ''}`
  if (_val && _val.match(/^\d+$/gi)) {
    return {
      field: fieldName,
      operator: 'EQUAL',
      value: _val,
      type: 'Long'
    }
  }
  return null
}

export function convertCiteriaByParams (fieldName, value, type, operator = 'EQUAL') {
  return {
    field: fieldName,
    operator: operator,
    value: value,
    type: type
  }
}
